import React from 'react';
import { 
  Chart as ChartJS, 
  ArcElement, 
  Tooltip, 
  Legend, 
  CategoryScale,
  LinearScale,
  BarElement,
  Title
} from 'chart.js';
import { Doughnut, Bar } from 'react-chartjs-2';

// Register ChartJS components
ChartJS.register(
  ArcElement, 
  Tooltip, 
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title
);

const ChartJSCard = ({ 
  title, 
  type = 'doughnut', 
  data, 
  options = {}, 
  isDarkMode = false 
}) => {
  // Default chart options with dark mode support
  const defaultOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: isDarkMode ? '#fff' : '#666',
          font: {
            size: 12
          }
        }
      },
      title: {
        display: title ? true : false,
        text: title,
        color: isDarkMode ? '#fff' : '#333',
        font: {
          size: 16,
          weight: 'bold'
        }
      },
      tooltip: {
        backgroundColor: isDarkMode ? '#333' : '#fff',
        titleColor: isDarkMode ? '#fff' : '#333',
        bodyColor: isDarkMode ? '#fff' : '#333',
        borderColor: isDarkMode ? '#555' : '#ddd',
        borderWidth: 1
      }
    }
  };

  // Additional options for specific chart types
  const chartTypeOptions = {
    doughnut: {
      cutout: '70%'
    },
    bar: {
      scales: {
        x: {
          grid: {
            color: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'
          },
          ticks: {
            color: isDarkMode ? '#fff' : '#666'
          }
        },
        y: {
          grid: {
            color: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'
          },
          ticks: {
            color: isDarkMode ? '#fff' : '#666'
          }
        }
      }
    }
  };

  // Merge options
  const mergedOptions = {
    ...defaultOptions,
    ...(chartTypeOptions[type] || {}),
    ...options
  };

  return (
    <div className={`w-full h-80 ${isDarkMode ? 'text-white' : 'text-gray-800'}`}>
      {type === 'doughnut' && <Doughnut data={data} options={mergedOptions} />}
      {type === 'bar' && <Bar data={data} options={mergedOptions} />}
    </div>
  );
};

export default ChartJSCard; 